import { useMutation, useQueryClient } from 'react-query';
import { updateUser } from 'resources/user/workflows';


export default function useUserUpdate() {
  const queryClient = useQueryClient();

  return useMutation(
    (requestData) => updateUser(requestData),
    {
      onSuccess: (user) => {
        if (!user || user.isBadRequest) {
          return;
        }

        queryClient.invalidateQueries('user.currentUser');
        queryClient.invalidateQueries(['users.companyUsers', user.company_id]);
        queryClient.invalidateQueries(['users.userById', user.id]);
        queryClient.invalidateQueries(['users.getUsersByIds']); // Send invite modal
      },
    },
  );
}
